<template>
  <f7-app v-bind="f7params" >
    <f7-view main class="safe-areas" url="/"></f7-view>
    <f7-panel left cover resizable>
      <f7-view url="/panel-left/" links-view=".view-main"></f7-view>
    </f7-panel>
    <timeout></timeout>
    <!-- jiraSupportWidget></jiraSupportWidget-->
  </f7-app>
</template>

<script>
  import { ref, onMounted } from 'vue';
  import { f7, f7ready } from 'framework7-vue';
  import { XmarkSquare, Ant, ArrowRightSquare, Alarm } from 'framework7-icons';

  import routes from '../js/routes.js';
  import store from '../js/store.js';
  import Keycloak from 'keycloak-js';
  import jiraSupportWidget from '../components/jirasupport.vue';
  import timeout from '../components/timeout.vue';
  import { getCurrentInstance } from "vue";

  export default {
    components:{
      jiraSupportWidget,
      timeout,
    },
    props: {
      f7route: Object,
      f7router: Object,
      kitty: String,
    },
    setup() {
      const f7params = {
        name: 'suntio', 
        theme: 'auto', 
        store: store,
        routes: routes,
        // keycloak: Keycloak,
      };

      onMounted(() => {
        f7ready((f7) => {
          let tempCSS = document.createElement('link');
          tempCSS.rel = 'stylesheet';
          tempCSS.href = window.session_theme;
          document.head.appendChild(tempCSS);

          // clean window
          delete window.ice_server_credential;
          delete window.ice_server_urls;
          delete window.ice_server_username;
          delete window.janus_debug;
          delete window.janus_url_list;
          delete window.keycloak_edit_client_id;
          delete window.keycloak_edit_realm;
          delete window.keycloak_edit_url;
          delete window.session_client_id;
          delete window.session_lang;
          delete window.session_logo;
          delete window.session_theme;
          delete window.token;

          // Call F7 APIs here
          f7.on('request_error', function (xhr, status, message, self) {
            let response = JSON.parse(xhr.response);
            let token=localStorage.token;
            switch(status) {
              case 500:
              case 419:
                localStorage.clear();
                f7.dialog.alert(self.$t('general_session-expired-label'));
                f7.views.main.router.navigate("/homing/"+token);
                break;
              case 456:
                localStorage.clear();
                f7.dialog.alert(self.$t('general_session-expired-label'));
                window.location.href=response.redirect_to;
                break;
              case 422:
                let key=Object.keys(response.errors)[0];
                let value=String(Object.values(response.errors)[0]);
                if(key==='national_id') {
                  let value_array=value.split(":",2);
                  let err_code=value_array[0];
                  let err_msg=value_array[1];
                  if(err_code==1003) {
                    f7.dialog.confirm(
                      self.$t('register_user-already-exists'),
                      "("+err_code+") "+ self.$t(err_msg),
                      ()=>{
                        self.$keycloak.login();
                      });
                  } else {
                    f7.dialog.alert("("+err_code+") "+self.$t(err_msg));
                  }
                }
                break;
              default:
                f7.dialog.alert('('+status+') '+message, self.$t('error'));
            }

          });
          f7.on('419', function() {
            console.log("got a 419");
          });
          f7.on('422', function() {
            console.log("got a 422");
          });
          f7.on('500', function() {
            console.log("got a 500");
          });
/* 
          f7.on('routeChange', function(newRoute, previousRoute, router) {
            console.log("got a routeChange");
          }); 
*/
/*
          f7.on('terminate', function (redirect_to) {
            console.log('received a call to terminate and redirect to ' + redirect_to);
            if("http" == redirect_to.substring(0,4))
              window.location.href=redirect_to;
            f7.views.main.router.navigate('/home');
          });
*/
        });
      });

      return {
        f7params,
      }
    }
  }
</script>

